/** @prettier */

/**
 * ダウンロードダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//Style import
import '../../css/common/common.css';

import {file} from '../../define';

/**
 * 言語ファイルダウンロードダイアログ
 * @param props props
 * @returns JSX
 */
const LanguageDownloadDialog = (props: {
  /** ダイアログ表示フラグ */
  isOpenDialog: boolean;
  /** ダイアログ表示フラグ設定関数 */
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const trans = useTranslation().t; //翻訳関数

  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ

  /**
   * DOWNLOADボタン押下時処理
   */
  const downloadFile = async () => {
    const url = `${process.env.PUBLIC_URL}/customLanguage/${file.CUSTOM_LANGUAGE_NAME}`;
    const link = document.createElement('a');
    link.href = url;
    link.download = file.CUSTOM_LANGUAGE_NAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="language-download-dialog-title"
        maxWidth="xs">
        <DialogTitle id="language-download-dialog-title">
          {trans('WebsiteSettingDownloadDialog.language.title')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="accountSetting__dialog__content__text">
            {trans('WebsiteSettingDownloadDialog.language.content')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            onClick={handleClose}
            buttonText={trans('WebsiteSettingDownloadDialog.buttonTxt.cancel')}
          />
          <PrimaryButton
            onClick={downloadFile}
            buttonText={trans(
              'WebsiteSettingDownloadDialog.buttonTxt.download'
            )}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
      />
    </>
  );
};

export {LanguageDownloadDialog};
